export const PrintAltIcon = () => (
  <svg className="mc-icon-svg" xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 25 25">
    <path
      fill="#fff"
      d="M16.7,8.2H8.3v1.1h8.3V8.2z M16.7,10.3H8.3v1.1h8.3V10.3z M16.7,13.6H8.3v-1.1h8.3V13.6z M24,12.5h-3.1V19 H4.2v-6.5H1v10.8H24V12.5z M5.2,17.9h14.6V7.1c0-1.4-2.1-2.4-3.1-2.2c0.5-0.9-0.6-3.2-2.1-3.2H5.2V17.9z M25,11.4v12.9H0V11.4h4.2 V0.7h10.8c1.9,0,5.9,4.3,5.9,6.5v4.3H25z"
    />
  </svg>
);
